/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "./type";
/**
 * @hidden
 */
var DataSourceRowExpansionChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataSourceRowExpansionChangedEventArgs, _super);
    function DataSourceRowExpansionChangedEventArgs(a, b, c) {
        var _this = _super.call(this) || this;
        _this.f = -1;
        _this.c = false;
        _this.b = false;
        _this.f = a;
        _this.c = b;
        _this.b = c;
        return _this;
    }
    Object.defineProperty(DataSourceRowExpansionChangedEventArgs.prototype, "rowIndex", {
        get: function () {
            return this.f;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSourceRowExpansionChangedEventArgs.prototype, "oldState", {
        get: function () {
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSourceRowExpansionChangedEventArgs.prototype, "newState", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    DataSourceRowExpansionChangedEventArgs.$t = markType(DataSourceRowExpansionChangedEventArgs, 'DataSourceRowExpansionChangedEventArgs', EventArgs.$);
    return DataSourceRowExpansionChangedEventArgs;
}(EventArgs));
export { DataSourceRowExpansionChangedEventArgs };
//# sourceMappingURL=DataSourceRowExpansionChangedEventArgs.js.map
